var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyFinanceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3393 0.445312H19.6494H6.52922H5.53571H1.33929H0.5V1.2846V5.48103V6.47453V9.52324V10.5167V14.7132V15.5525H1.33929H5.53571H6.52922H19.6494H20.3393V12.9465C20.1934 13.2444 20.0723 13.5545 19.9776 13.8739H6.20094C5.91958 12.9251 5.40528 12.0573 4.7002 11.3523C3.99511 10.6472 3.12736 10.1329 2.17857 9.85152V6.14625C3.12736 5.86489 3.99511 5.35059 4.7002 4.64551C5.40528 3.94042 5.91958 3.07268 6.20094 2.12388H19.9776C20.0723 2.44322 20.1934 2.75338 20.3393 3.05125V0.445312ZM2.17857 2.12388H4.41876C4.20532 2.61929 3.89903 3.07281 3.51327 3.45858C3.1275 3.84435 2.67397 4.15063 2.17857 4.36407V2.12388ZM3.51327 12.5392C3.89903 12.925 4.20532 13.3785 4.41876 13.8739H2.17857V11.6337C2.67397 11.8471 3.1275 12.1534 3.51327 12.5392ZM10.5714 7.99888C10.5714 6.60831 11.6987 5.48103 13.0893 5.48103C14.4799 5.48103 15.6071 6.60831 15.6071 7.99888C15.6071 9.38946 14.4799 10.5167 13.0893 10.5167C11.6987 10.5167 10.5714 9.38946 10.5714 7.99888ZM13.0893 3.80246C10.7717 3.80246 8.89286 5.68126 8.89286 7.99888C8.89286 10.3165 10.7717 12.1953 13.0893 12.1953C15.4069 12.1953 17.2857 10.3165 17.2857 7.99888C17.2857 5.68126 15.4069 3.80246 13.0893 3.80246Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFinanceActive);
export default __webpack_public_path__ + "static/media/MyFinanceActive.4743ed0cbad6a0ae077d5da266494bf8.svg";
export { ForwardRef as ReactComponent };